import { ParentMenuProps } from '@toasttab/shared/src/data/HeaderNavigation/MainNavigationMenu.d'

const RestaurantTypes: ParentMenuProps = {
  label: 'Restaurant Types',
  heapClass: 'au_topnav_rx',
  showcaseMobile: true,
  showcaseEntries: [
    {
      url: '/restaurant-pos',
      badge: {
        color: 'bg-sky-25',
        label: 'Featured'
      },
      title: 'Restaurant POS',
      heapClass: 'au_nav_rxpos',
      thumbnail:
        'https://images.ctfassets.net/tgv5pu8pgmos/6AA5zvrr7k1tquX2OFsaUs/2fa74f1a7bd16747e3767e91dd917b26/f20b024ec1b56372a73d1fb8bae944df10af6b5d.jpg?w=128&h=112&fit=fill',
      description: 'A powerful POS system designed for the guest experience.'
    },
    {
      title: 'Switch to Toast',
      description: 'Outgrown your tech? Toast makes switching easy.',
      heapClass: 'au_nav_switch',
      thumbnail:
        'https://d2w1ef2ao9g8r9.cloudfront.net/images/images/switching-to-toast-article-thumbnail.jpg',
      badge: {
        label: 'Featured',
        color: 'bg-sky-25'
      },
      icon: 'before:content-icon-solutions-contactless',
      url: '/restaurant-pos/switch-to-toast'
    },
    {
      title: 'Opening a new restaurant',
      description:
        "We'll handle the tech, so you can focus on what matters most.",
      heapClass: 'au_nav_nro',
      thumbnail:
        'https://d2w1ef2ao9g8r9.cloudfront.net/images/images/opening-a-new-restaurant-article-thumbnail.jpg',
      badge: {
        label: 'Featured',
        color: 'bg-sky-25'
      },
      icon: 'before:content-icon-solutions-back-of-house',
      url: '/restaurant-pos/new-restaurant-opening'
    }
  ],
  subMenus: [
    {
      label: 'Service models',
      showLabelMobile: false,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Full service',
          icon: 'before:content-icon-restaurant-types-full-service',
          url: '/restaurant-pos/full-service-pos-system',
          heapClass: 'au_nav_fsr'
        },
        {
          label: 'Quick service',
          icon: 'before:content-icon-restaurant-types-quick-service',
          url: '/restaurant-pos/quick-service-pos-system',
          heapClass: 'au_nav_qsr'
        },
        {
          label: 'Fast casual',
          icon: 'before:content-icon-restaurant-types-fast-casual',
          url: '/restaurant-pos/fast-casual',
          heapClass: 'au_nav_fastcasual'
        }
      ]
    },
    {
      label: 'Restaurant concepts',
      showLabelMobile: false,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Bar and lounge',
          icon: 'before:content-icon-restaurant-types-bar-nightclub',
          url: '/restaurant-pos/bar-pos',
          heapClass: 'au_nav_bar'
        },
        {
          label: 'Fine dining',
          icon: 'before:content-icon-restaurant-types-fine-dining',
          url: '/restaurant-pos/fine-dining',
          heapClass: 'au_nav_fine'
        },
        {
          label: 'Pizza',
          icon: 'before:content-icon-restaurant-types-pizzeria',
          url: '/restaurant-pos/pizza-pos',
          heapClass: 'au_nav_pizza'
        },
        {
          label: 'Cafe and bakery',
          icon: 'before:content-icon-restaurant-types-cafe-bakery',
          url: '/restaurant-pos/cafe-bakery',
          heapClass: 'au_nav_cafe'
        },
        {
          label: 'Casual dining',
          icon: 'before:content-icon-restaurant-types-casual-dining',
          url: '/restaurant-pos/casual-dining',
          heapClass: 'au_nav_casual'
        },
        {
          label: 'Hotel restaurant',
          icon: 'before:content-icon-restaurant-types-hotels',
          url: '/restaurant-pos/hotel-restaurant',
          heapClass: 'au_nav_hotel'
        }
      ]
    }
  ]
}

export default RestaurantTypes
